import { FileDown } from "lucide-react";

export const AgreementCopy = ({ record }) => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/gtax/agreements/${record.reference}/pdf?email=${encodeURIComponent(record.email)}`;
  const tg = window.Telegram?.WebApp;
  const open = (e) => { if (tg?.initData) { e.preventDefault(); tg.openLink(url); } };
  return (
    <a href={url} onClick={open} className="gx-ghost inline-flex items-center gap-2" data-testid="gtax-agreement-pdf">
      <FileDown size={16} /> Download signed agreement (PDF)
    </a>
  );
};
